module.exports = __webpack_public_path__ + "static/img/logga_medium.b3d8629.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logga_medium.png
// module id = 5w7P
// module chunks = 1